import { render, staticRenderFns } from "./TipsSetting.vue?vue&type=template&id=7db09dd6&scoped=true&"
import script from "./TipsSetting.vue?vue&type=script&lang=js&"
export * from "./TipsSetting.vue?vue&type=script&lang=js&"
import style0 from "./TipsSetting.vue?vue&type=style&index=0&id=7db09dd6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7db09dd6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCardText,VCol,VContainer,VRow})
